export const compareVersions = (current: string, target: string): number => {
  if (current === target) return 0;

  const currentParts = current.split('.').map(Number);
  const targetParts = target.split('.').map(Number);
  const maxLength = Math.max(currentParts.length, targetParts.length);

  for (let i = 0; i < maxLength; i++) {
    const currentPart = currentParts[i] || 0;
    const targetPart = targetParts[i] || 0;

    if (currentPart < targetPart) return -1;
    if (currentPart > targetPart) return 1;
  }

  return 0;
};

export const isVersionOlder = (current: string, target: string): boolean => {
  return compareVersions(current, target) === -1;
};

export const isVersionNewerOrEqual = (current: string, target: string): boolean => {
  return compareVersions(current, target) >= 0;
};

export const isValidVersion = (version: string): boolean => {
  const versionRegex = /^\d+\.\d+\.\d+$/;
  return versionRegex.test(version);
};

